<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <!-- logo -->
    <div class="logo">
      <img
        v-if="bannerArr.length > 0"
        :src="$imgUrl + bannerArr[0].thumb"
        alt=""
      />
    </div>
    <div class="container">
      <div class="ex_list" v-loading="loading" v-if="articleList.length > 0">
        <div
          class="ex_item"
          v-for="(item, index) in articleList"
          :key="index"
          @click="tapnewsDetail(item)"
        >
          <!-- <img :src="$imgUrl+item.image" /> -->
          <div class="news_title">{{ item.title }}</div>
          <div class="news_time">{{ item.create_time }}</div>
        </div>
      </div>
      <div class="nodata_box" v-if="articleList.length == 0">
        <nodata></nodata>
      </div>
      <div class="ex_footer">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="search.page_size"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- <div class="ex_list" v-loading="loading" v-if="articleList.length > 0">
        <div
          class="ex_item"
          v-for="(item, index) in articleList"
          :key="index"
          @click="tapnewsDetail(item)"
        >
          <img :src="$imgUrl+item.image" />
          <div class="news_title">{{ item.title }}</div>
          <div class="news_time">{{ item.create_time }}</div>
        </div>
      </div>
      <div class="nodata_box">
        <nodata></nodata>
      </div>
      <div class="ex_footer">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="search.page_size"
          :total="total"
        >
        </el-pagination>
      </div> -->
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>
  
  <script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import nodata from "../../components/nodata.vue";
import { getBanner, getArticle } from "@/api/api";
export default {
  components: { top, bottom, nodata },
  name: "newsList",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.langSet == "cn" ? this.keydata.name_cn : this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      search: {
        page_no: 1,
        page_size: 12,
      },
      langSet: "",
      bannerArr: [],
      articleList: [],
      total: 0,
      loading: false,
      cid: "",
      keydata: {},
    };
  },
  watch: {
    $route(to, from) {
      this.cid = this.$route.query.cid;
      this.getArticle();
    },
  },
  created() {},
  mounted() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    console.log(menuArr, "menuArr");
    menuArr.map((item) => {
      if (item.children) {
        item.children.map((i) => {
          if (i.name_cn == "BCEIA动态" || i.name_en == "BCEIA Dynamics") {
            this.keydata = i;
          }
        });
      }
    });
    this.cid = this.$route.query.cid;
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getArticle();
  },
  methods: {
    // zhang 获取新闻列表banner
    getBannerList() {
      let data = {
        class: "新闻列表",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 跳转新闻详情
    tapnewsDetail(item) {
      this.$router.push({
        name: "newsDetail",
        query: {
          id: item.id,
        },
      });
    },
    // zhang 获取最新动态数据
    getArticle() {
      this.loading = true;
      let data = { ...this.search, lang: this.langSet };
      if (this.cid) {
        data.cid = this.cid;
      }
      getArticle(data)
        .then((res) => {
          if (res.code == 1) {
            this.articleList = res.data.lists;
            this.total = res.data.count;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 切换分页
    handleCurrentChange(val) {
      this.search.page_no = val;
      this.getArticle();
    },
    // zhang 进去展商详情
    gotoDetail(item) {
      this.$router.push({
        path: "/exhibitorDetail",
        query: {
          company_long_id: item.company_long_id,
        },
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.nodata_box {
  margin: 100px 0 50px;
}
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.custom_btn {
  width: 120px;
  height: 50px;
  border-radius: 12px;
  border: 1px solid #243889;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
}
.search_btn {
  background: #243889;
  border-radius: 12px;
  color: #ffffff;
  margin: 0 20px;
}
.reset_btn {
  background: #f7f8fa;
  color: #2c2c2e;
}
.container {
  background: #fff;
  width: 900px;
  margin: 80px auto;
  .ex_footer {
    background: #fff;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
  }
  .search_box {
    display: flex;
    .custom_sel {
      position: relative;
      margin-right: 20px;
      .sel::placeholder {
        color: #000 !important;
      }
    }
  }
  .ex_tips {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 20px 0 10px;
  }
  .ex_list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 50px;
    .ex_item {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      // padding: 15px;
      box-sizing: border-box;
      background: #fff;
      border-bottom: 1px dashed #eee;
      // margin: 0 25px 50px 0;
      cursor: pointer;
      &:hover .news_title {
        color: #233889;
      }
      img {
        width: 100%;
        height: 230px;
      }
      .news_title {
        width: 70%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2e;
        line-height: 20px;
        margin: 11px 0 12px;
      }
      .news_time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2e;
      }
    }
  }
  .ex_list::after {
    content: "";
    flex: auto;
  }
  .search_value {
    width: 815px;
    height: 50px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #dddddd;
    padding-left: 55px;
    box-sizing: border-box;
  }
  .search_value::placeholder {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}
@media only screen and (max-width: 1280px) {
  .ex_item {
    width: initial !important;
    flex-wrap: wrap !important;
    padding: 10px 15px;
    box-sizing: border-box;
    // margin: 0 25px 50px 0 !important;
  }
  .container {
    width: 90% !important;
    margin: 0 auto !important;
  }
  .news_title {
    width: initial !important;
  }
  .ex_footer {
    margin-bottom: 50px;
  }
}

@media only screen and (max-width: 767px) {
  .container {
    width: 90% !important;
    margin: 0 auto !important;
  }
  .news_title {
    width: 100% !important;
  }
  .logo {
    width: 100%;
    height: 81px !important;
    margin-top: 0.88rem;
    img {
      width: 100%;
      height: 81px !important;
    }
  }
  .container .ex_list .ex_item {
    width: 100% !important;
    padding: 10px 15px;
    box-sizing: border-box;
  }
  .ex_footer {
    margin-bottom: 50px;
  }
}
</style>
  <style>
.exhibitorList_box .el-select {
  width: 165px;
  height: 50px;
}
.exhibitorList_box .el-select .el-input__inner {
  height: 50px;
  background: #f7f8fa;
  border-radius: 12px;
  border: none;
}
.exhibitorList_box .el-select > .el-input {
  height: 50px;
}
.exhibitorList_box .el-select .el-input .el-select__caret {
  color: #000;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #243889;
  border-radius: 4px;
  border: 1px solid #243889;
}
</style>